/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function UnLock({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.786 10.355a.7.7 0 0 1 .097-.385 1 1 0 1 0-1.766 0c.064.12.11.25.097.385l-.159 1.595a.5.5 0 0 0 .498.55h.895a.5.5 0 0 0 .497-.55z" /><path fill="currentColor" fillRule="evenodd" d="M5.64.536A3.62 3.62 0 0 0 4.025 5.39l.255.51H4a2.6 2.6 0 0 0-2.6 2.6v5A1.6 1.6 0 0 0 3 15.1h10a1.6 1.6 0 0 0 1.6-1.6v-5A2.6 2.6 0 0 0 12 5.9H5.592a.6.6 0 0 0-.055-.168l-.44-.879a2.418 2.418 0 0 1 4.312-2.19l.058.112a.6.6 0 0 0 1.066-.55l-.057-.112A3.62 3.62 0 0 0 5.64.536M4 7.1a1.4 1.4 0 0 0-1.4 1.4v5c0 .22.18.4.4.4h10a.4.4 0 0 0 .4-.4v-5A1.4 1.4 0 0 0 12 7.1z" clipRule="evenodd" /></svg>;
}
;